module.exports = __webpack_public_path__ + "img/position.c56ed08d.gif";